/**
 * DAAM Leads — Paywall banner
 * ---------------------------------------------------------------
 * Rendered inline on the DAAM Leads pages (/app/leads,
 * /app/leads/analytics) when the backend responds with 402
 * ACTIVE_SUBSCRIPTION_REQUIRED or UPGRADE_REQUIRED. The api.js
 * interceptor already handles the soft-redirect to /app/plans,
 * but this banner gives the user a visible, on-page CTA in case
 * they've dismissed the toast or landed here after a race.
 *
 * We intentionally DO NOT mirror the entire backend gate reason
 * enum here — this component is a static, brand-approved copy
 * block; per-plan reason messages are surfaced by the toast.
 */
import React from "react";
import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Sparkles } from "lucide-react";

export function LeadsPaywallBanner({
  title    = "فعّل اشتراكك لاستخدام DAAM Leads",
  message  = "أنشئ صفحة نشاطك، قِس الزيارات والنقرات، واعرف أي منصة تحقق نتائج أفضل.",
  ctaLabel = "عرض الباقات",
  ctaTo    = "/app/plans",
  testId   = "leads-paywall-banner",
}) {
  return (
    <Card data-testid={testId}
          className="border-amber-200 bg-gradient-to-br from-amber-50 to-white">
      <CardContent className="p-6 sm:p-8" dir="rtl">
        <div className="flex items-start gap-4">
          <div className="mt-1 flex h-10 w-10 shrink-0 items-center
                          justify-center rounded-xl bg-amber-100 text-amber-700">
            <Sparkles className="h-5 w-5" />
          </div>
          <div className="flex-1">
            <h2 className="text-base font-semibold text-neutral-900">
              {title}
            </h2>
            <p className="mt-1 text-sm text-neutral-600 leading-6">
              {message}
            </p>
            <div className="mt-4">
              <Button asChild
                      data-testid={`${testId}-cta`}
                      className="bg-neutral-900 hover:bg-neutral-800 text-white">
                <Link to={ctaTo}>{ctaLabel}</Link>
              </Button>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

export default LeadsPaywallBanner;
